.root {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.title {
  align-items: center;
  display: flex;
  gap: 8px;
}

.title-emoji {
  font-size: 20px;
}

.section {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
}

.section-heading {
  align-items: center;
  color: var(--color-muted);
  display: flex;
  font-size: 11px;
  font-weight: 600;
  gap: 6px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.section-row {
  align-items: center;
  display: flex;
  gap: 8px;
}

.section-key {
  min-width: 64px;
}

.picks-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.picks-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pick-row {
  align-items: center;
  display: flex;
  gap: 10px;
}

.pick-thumb {
  background: var(--color-secondary);
  border-radius: 6px;
  flex: 0 0 auto;
  height: 36px;
  object-fit: cover;
  width: 36px;
}

.pick-thumb-placeholder {
  background: var(--color-secondary);
  border-radius: 6px;
  flex: 0 0 auto;
  height: 36px;
  width: 36px;
}

.pick-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.pick-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pick-subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.actions {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
